module.exports = __webpack_public_path__ + "img/00-menu-bar-off_04.6ff7af94.png";